import { Router } from "@reach/router";
import FieldReportsFooterPage from "pages/FieldReportsPage/FieldReportsFooterPage";
import FieldReportsPage from "pages/FieldReportsPage/FieldReportsPage";
import IntegrationLoading from "pages/IntegrationLoading/IntegrationLoading";
import InvoicesFooterPage from "pages/InvoicesPage/InvoicesFooterPage";
import InvoicesPage from "pages/InvoicesPage/InvoicesPage";
import React from "react";
import {
  Provider,
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createEpicMiddleware } from "redux-observable";
import thunk from "redux-thunk";
import { rootEpic, rootReducer } from "./reducers/rootReducer";
import MainRouter from "./routes/MainRouter/MainRouterContainer";
import "./styles/Main.scss";

// TODO: Move all Redux realted items to a more appropriate location
const isProduction = process.env.REACT_APP_BUILD_TYPE === "Production";

const composeEnhancers = isProduction
  ? compose
  : composeWithDevTools({ trace: true });

const epicMiddleware = createEpicMiddleware();

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, epicMiddleware))
);
type AppDispatch = typeof store.dispatch;
type ReduxStore = ReturnType<typeof store.getState>;

/**
 * Import this instead of importing `useDispatch` from "react-redux".
 */
export const useAppDispatch: () => AppDispatch = useDispatch;
/**
 * Import this instead of importing `useSelector` from "react-redux".
 */
export const useAppSelector: TypedUseSelectorHook<ReduxStore> = useSelector;

epicMiddleware.run(rootEpic);

const App: React.FC = () => {
  return (
    <>
      <Provider store={store}>
        <Router primary={false} className="PreRouter">
          <InvoicesPage path="/template/subscription-invoice" />
          <InvoicesFooterPage path="/template/subscription-invoice-footer" />
          <FieldReportsPage path="/template/field-report" />
          <FieldReportsFooterPage path="/template/field-report-footer" />
          <IntegrationLoading path="/template/integration-loading" />
          <MainRouter default />
        </Router>
      </Provider>
    </>
  );
};

export default App;
